import React, { useEffect, useState } from "react"
import { IoEye, IoEyeOff } from "react-icons/io5"
import { v4 as uuid } from "uuid"
import { AlertType, TypePasswordProps, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from "../../Utils/Types"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { FaTrashAlt } from "react-icons/fa"
import { TbShoppingCartOff } from "react-icons/tb"

type Props = {
    show: boolean,
    isLoading?: boolean,
    message: string,
    alertType?: AlertType,
    feedBackVisible?: boolean,
    messageFeedBack?: string,
    cancelarVenda?: boolean,
    excluirEvent?: (motivoExclusao: string, senha: string) => void,
    closeModalEvent?: () => void,
    fecharModalEvent: () => void,
}

export const ModalExcluirDados = React.memo(({ show, isLoading, message, alertType = "SUCCESS", feedBackVisible = false, messageFeedBack = '', cancelarVenda, excluirEvent, closeModalEvent, fecharModalEvent }: Props) => {

    const [loading, setLoading] = useState(false)

    const [id, setId] = useState(0)
    const [divId, setDivId] = useState("")
    const [divIdContent, setDivIdContent] = useState("")

    const [motivo, setMotivo] = useState("")
    const [senha, setSenha] = useState("")

    const [showPassword, setShowPassword] = useState(false);
    const [passwordInputType, setPasswordInputType] = useState<TypePasswordProps>("password");

    useEffect(() => {
        setDivId(uuid())
        setDivIdContent(uuid())
    }, [])

    useEffect(() => {

        if (show) {

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 150)

            let modal = document.getElementById(divId)
            let modalContent = document.getElementById(divIdContent)

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById(divId)

            if (modal) {
                modal.style.visibility = 'hidden'
                let modalContent = document.getElementById(divIdContent)

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }

            setMotivo('')
            setSenha('')
        }
    }, [show])

    const handleChangeMotivo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMotivo(e.target.value)
    }

    const handleChangeSenha = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenha(e.target.value)
    }

    const eventExclusao = (motivoExclusao: string, senha: string) => {
        if (excluirEvent) {
            excluirEvent(motivoExclusao, senha)
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
        setPasswordInputType(!showPassword ? 'text' : 'password');
    }

    const fecharModalMSG = () => {

        if (closeModalEvent) {
            closeModalEvent()
        }
    }

    const fecharModal = () => {

        if (fecharModalEvent) {
            fecharModalEvent()
        }

    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("motivo")
        inputElement?.focus()
    }

    return (

        <div id={divId} style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id={divIdContent} className={`relative flex flex-col w-[90%] sm:w-[70%] md:w-[60%] lg:w-[40%] xl:w-[30%] h-[350px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={feedBackVisible} message={messageFeedBack} type={alertType} onCloseMessage={fecharModalMSG} />

                {/* Header */}
                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center `}>
                    {cancelarVenda &&
                        <div className={`mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#8f3838] border-2 border-[#FC5F4D] shadow-sm shadow-black mt-6 mb-4`}>
                            <TbShoppingCartOff className={`text-red-400 w-8 h-8`} />
                        </div>
                    }
                    {!cancelarVenda &&
                        <div className={`mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#8f3838] border-2 border-[#FC5F4D] shadow-sm shadow-black mt-6 mb-4`}>
                            <FaTrashAlt className={`text-red-400 w-8 h-8`} />
                        </div>
                    }

                </div>

                {/* Body */}
                <div className={`absolute top-[70px] w-full px-1 py-2 flex justify-center`}>
                    <span className={`text-base text-slate-500 dark:text-slate-200 `}>{message}</span>
                </div>

                <div className={`absolute top-[130px] bottom-[60px] w-full p-4 grid grid-cols-4 gap-4`}>

                    <div className={`relative col-span-4`}>
                        <input id="motivo" className={`${classInput} ${classInputDark}`} type="text" placeholder=" " maxLength={100} value={motivo} autoComplete="off" onChange={handleChangeMotivo} />
                        <label htmlFor="motivo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Motivo</label>
                    </div>

                    <div className={`relative col-span-4`}>

                        <div className={`relative`}>

                             { /* recurso utilizado para o navegador não jogar o email do usuário nesse campo */ }
                            <input
                                type="password"
                                name="fake_autofill_field"
                                style={{ display: 'none' }}
                                autoComplete="new-password"
                            />

                            <input type={passwordInputType} id="password" className={`${classInput} ${classInputDark} pr-11`} placeholder=" " value={senha} autoComplete="off" onChange={handleChangeSenha} />
                            <label htmlFor="password" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Senha</label>
                            <button onClick={toggleShowPassword} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none`}>

                                {showPassword &&
                                    <IoEye size="30px" />
                                }

                                {!showPassword &&
                                    <IoEyeOff size="30px" />
                                }

                            </button>
                        </div>


                    </div>

                </div>
                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>
                    <button
                        tabIndex={-1}
                        disabled={isLoading}
                        onClick={fecharModal}
                        className={`${isLoading ? 'opacity-40' : ''}
                        ${classbtColunasVermelho} md:max-w-[150px]`}>
                        {cancelarVenda ? 'VOLTAR' : 'CANCELAR'}
                    </button>

                    <button
                        tabIndex={-1}
                        disabled={isLoading}
                        onClick={() => eventExclusao(motivo, senha)}
                        className={`${isLoading ? 'opacity-40' : ''} 
                        ${classbtAzul} ${classBt} md:max-w-[150px]`}>

                        {isLoading &&
                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                role="status">
                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                        }
                        {isLoading ? 'AGUARDE...' : cancelarVenda ? 'CANCELAR VENDA' : 'EXCLUIR'}
                    </button>
                </div>
                {/* Footer */}

            </div>

        </div>
    )
})